// extracted by mini-css-extract-plugin
module.exports = {"overAll":"questionnaire_overAll__QWQft","resStyle":"questionnaire_resStyle__1m-it"};